
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useState } from 'react';
import styled from 'styled-components';
import Page from 'shared/components/Page';
import JobBoard from 'modules/jobBoard/board';
import { backend, frontend } from 'modules/jobBoard/offer';
import Head from 'next/head';
const HeaderSection = styled.header `
  font-size: 2.4rem;
  display: flex;
  padding: 2% 2.4rem;
  justify-content: center;
  text-align: center;
  align-items: center;
  text-transform: uppercase;
  color: white;
  height: 100%;
  background: ${({ theme }) => theme.COLORS.PRIMARY_GRADIENT};
  position: relative;
  font-family: ${({ theme }) => theme.FONTS.SECONDARY};

  &:before {
    content: '';
    position: absolute;
    opacity: 0.04;
    background: url('/img/jobsPage/bg-2.png');
    background-position: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  @media ${({ theme }) => theme.DEVICE.LG} {
    font-size: 3.6rem;
  }
`;
const MailContainer = styled.div `
  margin: 0.8rem 2.4rem 6.4rem 2.4rem;
  font-size: 2.2rem;
  color: ${({ theme }) => theme.COLORS.PRIMARY};
  text-align: center;
  font-weight: 700;
  display: flex;
  justify-content: center;
  flex-direction: column;

  @media ${({ theme }) => theme.DEVICE.LG} {
    flex-direction: row;
    margin-bottom: 8rem;
  }

  span {
    margin-right: 0.4rem;
  }

  a {
    color: ${({ theme }) => theme.COLORS.SECONDARY};
    unicode-bidi: bidi-override;
    direction: rtl;
  }
`;
const StyledP = styled.p `
  cursor: pointer;
  text-decoration: underline;
  font-weight: 400;
  color: ${({ theme }) => theme.COLORS.SECONDARY};
`;
function JobsPage(): JSX.Element {
    const [visible, setVisible] = useState(false);
    return (<Page withHubspot={false} withWidget={false} withLatestReviews={false}>
      <Head>
        <title>Kariera TrustMate</title>
      </Head>
      <HeaderSection>
        <div>
          <h1>Oferty pracy</h1>
        </div>
      </HeaderSection>
      <main>
        <JobBoard position={frontend}/>
        <JobBoard position={backend}/>
        <MailContainer>
          <span>Pytania i CV wysyłajcie na: </span>
          {visible ? (<a href="&#109;a&#105;lto&#58;m&#105;&#99;hal&#46;z&#37;6&#49;g%64a%6E&#64;tr%75stma%74e&#46;i&#37;6F">
              &#111;i&#46;e&#116;am&#116;&#115;urt&#64;n&#97;&#100;ga&#122;&#46;la&#104;cim
            </a>) : (<StyledP role="button" onClick={() => setVisible(true)}>
              pokaż adres email
            </StyledP>)}
        </MailContainer>
      </main>
    </Page>);
}
export default JobsPage;

    async function __Next_Translate__getStaticProps__1968611efc7__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/jobs',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1968611efc7__ as getStaticProps }
  